import { doGet, doPost, doPut } from 'hooks/requests';

export const useSeatGeekService = () => {
    const addToken = (data) => doPost(`/seat-geek/add-token/`, data);
    const getToken = (data) => doGet(`/seat-geek/get-token/?company_id=${data.companyId}`);
    const updateToken = (data) => doPut(`/seat-geek/update-token/`, data);

    const getSeatGeekPayments = (companyId) => doPost(`/seat-geek/sync-payments/`, { company_id: companyId });

    return {
        addToken,
        getToken,
        updateToken,
        getSeatGeekPayments,
    };
};
